import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const leadOrg = {
    "blockId": uuidv4(),
    "description": "<p>This section focuses on the following competencies: <strong>Vision & Strategy, Drive For Results, Decision-Making, Change Maker</strong>. Share how often you have experienced the leader demonstrating the below behaviors. Identify <strong>at least one behavior</strong> that the leader does not demonstrate often or always, as these highlight potential opportunities for growth. </p>",
    "selfDescription": "<p>This section focuses on the following competencies: <strong>Vision & Strategy, Drive For Results, Decision-Making, Change Maker</strong>. Share how often you demonstrate the below behaviors. Identify <strong>at least one behavior</strong> you don't demonstrate often or always, as these highlight potential opportunities for growth. </p>",
    "goalId": "dynamic360Strength",
    "isRequired": true,
    "feedbackBasedCondition": [
        {
            "answeringCondition": [
                {
                    "columnValues": ["1", "2"],
                    "numberOfAnswersNeeded": 3
                },
                {
                    "columnValues": ["3", "4"],
                    "numberOfAnswersNeeded": 3
                },
                {
                    "columnValues": ["5", "6"],
                    "numberOfAnswersNeeded": 3
                }
            ]
        }
    ],
    "allowNAOption": true,
    "questions": [
        {
            "question": "",
            "options": [
                { "label": "Never", "value": "1" },
                { "label": "Rarely", "value": "2" },
                { "label": "Occasionally", "value": "3" },
                { "label": "Sometimes", "value": "4" },
                { "label": "Often", "value": "5" },
                { "label": "Always", "value": "6" },
                { "label": "Can't answer", "value": "0" }
            ],
            "questionDimension": "Custom Matrix",
            "type": "matrix",
            "qid": uuidv4(),
            "matrixQuestions": [
                // Vision & Strategy
                {
                    "subCategoryId": generateStaticQuestionId("Vision & Strategy"),
                    "subCategory": "Vision & Strategy",
                    "staticQuestionId": generateStaticQuestionId("Creates actionable strategies to support long-term goals"),
                    "HTMLText": "<p>Creates actionable strategies to support long-term goals</p>",
                    "isSelected": true,
                    "text": "Creates actionable strategies to support long-term goals",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Vision & Strategy"),
                    "subCategory": "Vision & Strategy",
                    "staticQuestionId": generateStaticQuestionId("Aligns others by painting a clear picture of the future"),
                    "HTMLText": "<p>Aligns others by painting a clear picture of the future</p>",
                    "isSelected": true,
                    "text": "Aligns others by painting a clear picture of the future",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Vision & Strategy"),
                    "subCategory": "Vision & Strategy",
                    "staticQuestionId": generateStaticQuestionId("Identifies and guides others to navigate appropriate levels of risk"),
                    "HTMLText": "<p>Identifies and guides others to navigate appropriate levels of risk</p>",
                    "isSelected": true,
                    "text": "Identifies and guides others to navigate appropriate levels of risk",
                    "value": uuidv4()
                },

                // Drive For Results
                {
                    "subCategoryId": generateStaticQuestionId("Drive For Results"),
                    "subCategory": "Drive For Results",
                    "staticQuestionId": generateStaticQuestionId("Inspires others to work towards challenging but achievable goals"),
                    "HTMLText": "<p>Inspires others to work towards challenging but achievable goals</p>",
                    "isSelected": true,
                    "text": "Inspires others to work towards challenging but achievable goals",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Drive For Results"),
                    "subCategory": "Drive For Results",
                    "staticQuestionId": generateStaticQuestionId("Monitors progress to ensure goals and objectives are met or exceeded"),
                    "HTMLText": "<p>Monitors progress to ensure goals and objectives are met or exceeded</p>",
                    "isSelected": true,
                    "text": "Monitors progress to ensure goals and objectives are met or exceeded",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Drive For Results"),
                    "subCategory": "Drive For Results",
                    "staticQuestionId": generateStaticQuestionId("Takes action and shows initiative to support organizational goals"),
                    "HTMLText": "<p>Takes action and shows initiative to support organizational goals</p>",
                    "isSelected": true,
                    "text": "Takes action and shows initiative to support organizational goals",
                    "value": uuidv4()
                },

                // Decision-Making
                {
                    "subCategoryId": generateStaticQuestionId("Decision-Making"),
                    "subCategory": "Decision-Making",
                    "staticQuestionId": generateStaticQuestionId("Makes decisions in a timely manner"),
                    "HTMLText": "<p>Makes decisions in a timely manner</p>",
                    "isSelected": true,
                    "text": "Makes decisions in a timely manner",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Decision-Making"),
                    "subCategory": "Decision-Making",
                    "staticQuestionId": generateStaticQuestionId("Appropriately consults and involves others in decision making"),
                    "HTMLText": "<p>Appropriately consults and involves others in decision making</p>",
                    "isSelected": true,
                    "text": "Appropriately consults and involves others in decision making",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Decision-Making"),
                    "subCategory": "Decision-Making",
                    "staticQuestionId": generateStaticQuestionId("Utilizes available information from multiple sources when making decisions "),
                    "HTMLText": "<p>Utilizes available information from multiple sources when making decisions </p>",
                    "isSelected": true,
                    "text": "Utilizes available information from multiple sources when making decisions ",
                    "value": uuidv4()
                },

                // Change Maker
                {
                    "subCategoryId": generateStaticQuestionId("Change Maker"),
                    "subCategory": "Change Maker",
                    "staticQuestionId": generateStaticQuestionId("Actively supports and facilitates change to ensure shared success"),
                    "HTMLText": "<p>Actively supports and facilitates change to ensure shared success</p>",
                    "isSelected": true,
                    "text": "Actively supports and facilitates change to ensure shared success",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Change Maker"),
                    "subCategory": "Change Maker",
                    "staticQuestionId": generateStaticQuestionId("Works to remove obstacles or barriers to positive change"),
                    "HTMLText": "<p>Works to remove obstacles or barriers to positive change</p>",
                    "isSelected": true,
                    "text": "Works to remove obstacles or barriers to positive change",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Change Maker"),
                    "subCategory": "Change Maker",
                    "staticQuestionId": generateStaticQuestionId("Effectively communicates the reasoning for changes to build support and alignment"),
                    "HTMLText": "<p>Effectively communicates the reasoning for changes to build support and alignment</p>",
                    "isSelected": true,
                    "text": "Effectively communicates the reasoning for changes to build support and alignment",
                    "value": uuidv4()
                }
            ],
            "questionLabel": "Custom Matrix"
        }
    ],
    "isSelected": true,
    "type": "matrix",
    "dimension": "LEAD ORG"
};
